<form #form="ngForm"
      method="POST">

    <input-wrap>
        <div class="flex">

            <!-- input -->
            <input class="p1 p-l-2 p-r-2 b-a"
                   [tradeClass]="'!col-11 !b-col-b col-12 b-col-w'"
                   type="email"
                   name="email"
                   [(ngModel)]="data.email"
                   [attr.placeholder]="'Email address...' | translate"
                   loqateEmail
                   required
                   (keyup.enter)="submit()"
                   (click)="showSubmitButton = true"
                   (offClick)="showSubmitButton = false"
                   [offClickOff]="!showSubmitButton"
                   cy-subscribeMailInput>

            <!-- button / X, L, M, S -->
            <ng-container>
                <action [tradeClass]="'!button button-3'"
                        [status]="status"
                        sl-button="subscribe"
                        cy-subscribeButton
                        (click)="submit()">
                    <span class="no-wrap">{{'Sign up' | translate}}</span>
                </action>
            </ng-container>
        </div>
    </input-wrap>

    <input-wrap>
        <div class="m-t-3 m-b-2">
            @switch (isFooter) {
            @default {
            <checkbox [(ngModel)]="data.consent"
                      name="newsletter"
                      required>
                <span class="c1 privacy-policy"
                      [tradeClass]="'col-w'"
                      [innerHTML]="custom"></span>
            </checkbox>
            }
            @case (true) {
            <span class="c1 privacy-policy"
                  [tradeClass]="'col-w'"
                  [innerHTML]="custom"></span>
            }
            }
        </div>
    </input-wrap>

    <result class="block col-2 c1"
            sl-result="subscribe"
            cy-subscribeStatusMessage
            [status]="status"
            [success]="successMessage"></result>
</form>